import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const campusOffers = {
  // 获取校招列表
  getCampusOfferList: payload => {
    return api.get(proxyApi + `/v4/comp_recruit_infos`, payload)
  },
  // 获取校招详情
  getCampusOfferDetail: token => {
    return api.get(proxyApi + `/v4/comp_recruit_infos/${ token }`)
  },
  // 获取用户收藏列表
  getCampusFavorites: payload => {
    return api.get(proxyApi + `/v4/comp_recruit_infos/favorites_list`, payload)
  },
  // 修改校招职位关注状态
  updateCampusOfferLike: (token, payload) => {
    return api.put(proxyApi + `/v4/comp_recruit_infos/${ token }/like`, payload)
  },
  // 创建网申步骤
  createCampusRecruitment: payload => {
    return api.post(proxyApi + `/v3/campus_recruitments`, payload)
  },
  // 修改网申步骤
  updateCampusRecruitment: (id, payload) => {
    return api.put(proxyApi + `/v3/campus_recruitments/${id}`, payload)
  },
  // 获取校招日历月数据
  getCampusMonthCalendar: payload => {
    return api.get(proxyApi + `/v3/campus_calendar/month`, payload)
  },
  // 获取校招日历周数据
  getCampusWeekCanlendar: payload => {
    return api.get(proxyApi + `/v3/campus_calendar/week`, payload)
  },
  // 网申公司自动补全
  getCampusCompanyList: payload => {
    return api.get(proxyApi + `/v3/campus_recruitments/campany/auto_complete`, payload)
  },
  // 获取特定公司网申
  getCampusRecruitments: company_token => {
    return api.get(proxyApi + `/v3/campus_recruitments/recruit_infos/${company_token}`, {})
  },
  // 修改网申步骤状态
  updateCampusRecruitmentState: (id, payload) => {
    return api.put(proxyApi + `/v3/campus_recruitments/${id}/state`, payload)
  },
  // 获取网申步骤状态
  getCampusRecruitment: id => {
    return api.get(proxyApi + `/v3/campus_recruitments/${id}`, {})
  },
  // 获取特定网申的个人待办
  getRecruitmentInfoByCampusToken: (token) => {
    return api.get(proxyApi + `/v3/comp_recruit_infos/${token}/campus_recruitments`, {})
  },
  // 获取特定公司的个人待办
  getRecruitmentInfoByCompanyToken: company_token => {
    return api.get(proxyApi + `/v3/campus_recruitments/recruitments/${company_token}`, {})
  },
  // 删除待办
  deleteRecruitment: id => {
    return api.delete(proxyApi + `/v3/campus_recruitments/${id}`, {})
  },
  // 校招网申列表补全
  campusCompanyComplete: payload => {
    return api.get(proxyApi + `/v3/campus_companies`, payload)
  },
  // 收藏（关注）公司
  favoriteCompany: (payload) => {
    return api.post(proxyApi + `/v3/favorite_companies`, payload)
  },
  // 取消收藏（关注）公司
  unFavoriteCompany: (company_token) => {
    return api.delete(proxyApi + `/v3/favorite_companies/${company_token}`)
  },
  // 是否收藏（关注）公司
  getFavoriteCompanyState: (company_token) => {
    return api.get(proxyApi + `/v3/favorite_companies/${company_token}`)
  },
}

export default campusOffers
